import './App.css'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import { Home } from './Home'
import PrivacyPolicy from './PrivacyPolicy'
import { HashLink } from './HashLink'

export const App = () => {
  return (
    <Router>
      <div className="app">
        {/* Navigation */}
        <nav className="navbar">
          <div className="container">
            <div className="nav-brand" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img src="/idea2reality.png" alt="IDEA2REALITY" style={{ height: '40px' }} />
              IDEA2REALITY
            </div>
            <ul className="nav-menu">
              <li><HashLink to="/#home">Home</HashLink></li>
              <li><HashLink to="/#services">Services</HashLink></li>
              <li><HashLink to="/#about">About</HashLink></li>
              <li><HashLink to="/#contact">Contact</HashLink></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <p>&copy; 2025 IDEA2REALITY. All rights reserved.</p>
            <p><Link to="/privacy-policy" style={{ color: 'inherit', textDecoration: 'underline' }}>Privacy Policy</Link></p>
          </div>
        </footer>
      </div>
    </Router>
  )
}